(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["py-look-engine"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('py-look-recommendations')) {
    customElements.define('py-look-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.url || this.dataset.loading === 'true') return;
        this.dataset.loading = 'true';
        this.load();
      }
      async load() {
        const url = this.dataset.url;
        try {
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Recommendation request failed');
          const html = document.createElement('div');
          html.innerHTML = await response.text();
          const selector = `[data-py-look-recommendations="${CSS.escape(this.dataset.pyLookRecommendations)}"]`;
          const source = html.querySelector(selector);
          if (source?.querySelector('py-look-picker')) {
            this.replaceChildren(...source.cloneNode(true).childNodes);
            this.removeAttribute('data-url');
            this.removeAttribute('data-fallback-url');
            return;
          }
          if (this.dataset.fallbackUrl && url !== this.dataset.fallbackUrl) {
            this.dataset.url = this.dataset.fallbackUrl;
            await this.load();
            return;
          }
          this.replaceChildren();
          this.removeAttribute('data-url');
          this.removeAttribute('data-fallback-url');
        } catch (error) {
          if (this.dataset.fallbackUrl && url !== this.dataset.fallbackUrl) {
            this.dataset.url = this.dataset.fallbackUrl;
            await this.load();
            return;
          }
          this.removeAttribute('data-loading');
        }
      }
    });
  }
  if (!customElements.get('py-look-card')) {
    customElements.define('py-look-card', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-py-open]');
        this.trigger.addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.dialog.showModal();
          document.documentElement.classList.add('py-look-modal-open');
        }, options);
        this.querySelector('[data-py-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (!document.querySelector('.py-look-dialog[open]')) document.documentElement.classList.remove('py-look-modal-open');
          this.trigger.focus({ preventScroll: true });
        }, options);
      }
      disconnectedCallback() {
        this.events?.abort();
        if (!document.querySelector('.py-look-dialog[open]')) document.documentElement.classList.remove('py-look-modal-open');
      }
    });
  }
  if (!customElements.get('py-look-picker')) {
    customElements.define('py-look-picker', class extends HTMLElement {
      static pending = false;
      connectedCallback() {
        this.events?.abort();
        this.formObserver?.disconnect();
        this.carouselObserver?.disconnect();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        if (this.dataset.compact === 'true') this.setupCompactOptions();
        this.addEventListener('change', (event) => {
          const panel = event.target.closest('[data-py-extra-options]');
          const row = event.target.closest('[data-py-item]') || this.compactRows?.get(panel?.dataset.productId)?.row;
          if (row && event.target.matches('[data-py-option]')) {
            row.querySelector('[data-py-check]').checked = true;
            this.resolveCompactVariant(row);
          }
          if (row && event.target.matches('[data-py-variant]')) {
            const choice = event.target.selectedOptions[0];
            if (choice?.value && !choice.disabled) {
              row.querySelector('[data-py-check]').checked = true;
              row.querySelector('[data-py-price]').textContent = choice.dataset.money;
              const comparePrice = row.querySelector('[data-py-compare-price]');
              if (comparePrice) {
                const showComparePrice = Number(choice.dataset.comparePrice || 0) > Number(choice.dataset.price || 0);
                comparePrice.hidden = !showComparePrice;
                comparePrice.textContent = showComparePrice ? choice.dataset.compareMoney : '';
              }
              this.syncDrawerVariant(row, choice);
              const photo = row.querySelector('.py-look-item__photo');
              if (photo && choice.dataset.image) { photo.removeAttribute('srcset'); photo.src = choice.dataset.image; }
            }
          }
          if (row && event.target.matches('[data-py-quantity-input]')) this.setDrawerQuantity(row, event.target.value);
          this.clearCompactErrors();
          this.message('');
          if (this.dataset.compact === 'true') this.querySelector('[data-py-cart-link]').hidden = true;
          this.update();
        }, options);
        this.addEventListener('click', (event) => {
          const control = event.target.closest?.('[data-py-quantity-minus], [data-py-quantity-plus]');
          if (!control || !this.contains(control)) return;
          const row = control.closest('[data-py-item]');
          if (!row) return;
          event.preventDefault();
          this.changeDrawerQuantity(row, control.matches('[data-py-quantity-plus]') ? 1 : -1);
          this.message('');
          this.update();
        }, options);
        this.addEventListener('input', (event) => {
          if (!event.target.matches('[data-py-quantity-input]')) return;
          const row = event.target.closest('[data-py-item]');
          if (!row) return;
          this.setDrawerQuantity(row, event.target.value);
          this.message('');
          this.update();
        }, options);
        this.querySelector('[data-py-add]').addEventListener('click', (event) => this.submitExtras(event.currentTarget), options);
        this.querySelector('[data-py-prev]')?.addEventListener('click', () => this.scrollItems(-1), options);
        this.querySelector('[data-py-next]')?.addEventListener('click', () => this.scrollItems(1), options);
        if (this.dataset.compact === 'true') this.setupCarousel(options);
        this.form = this.dataset.productForm ? document.getElementById(this.dataset.productForm) : null;
        if (this.form) {
          this.productScope = this.closest('product-info') || this.closest('.product__info-container') || this.form.closest('section') || this.form;
          const schedulePricingUpdate = (event) => {
            if (this.contains(event.target)) return;
            queueMicrotask(() => { if (this.isConnected) this.update(); });
          };
          this.productScope.addEventListener('change', schedulePricingUpdate, options);
          this.productScope.addEventListener('input', schedulePricingUpdate, options);
          this.form.addEventListener('submit', (event) => {
            if (!this.selectedRows().length) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            const button = event.submitter || this.form.querySelector('[type="submit"]');
            if (button?.disabled || button?.getAttribute('aria-disabled') === 'true') return;
            const extras = this.getItems();
            if (!extras) return;
            const fields = new FormData(this.form);
            const main = { id: Number(fields.get('id')), quantity: Number(fields.get('quantity') || 1) };
            if (!Number.isSafeInteger(main.id) || main.id <= 0 || !Number.isInteger(main.quantity) || main.quantity < 1) { this.message(this.dataset.missing); return; }
            if (fields.get('selling_plan')) main.selling_plan = fields.get('selling_plan');
            for (const [key, value] of fields.entries()) {
              const property = key.match(/^properties\[(.*)\]$/);
              if (property && typeof value === 'string') { main.properties ||= {}; main.properties[property[1]] = value; }
              if (property && typeof value !== 'string' && value.size) { this.message(this.dataset.error); return; }
            }
            this.addItems([main, ...extras], button);
          }, { capture: true, signal: this.events.signal });
          this.formObserver = new MutationObserver(() => { this.updatePaymentButtons(); this.update(); });
          this.formObserver.observe(this.form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
        }
        this.querySelectorAll('[data-py-quantity-input]').forEach((input) => {
          const row = input.closest('[data-py-item]');
          if (row) this.setDrawerQuantity(row, input.value);
        });
        this.update();
      }
      disconnectedCallback() { this.events?.abort(); this.formObserver?.disconnect(); this.carouselObserver?.disconnect(); this.restorePaymentButtons(); }
      setupCarousel(options) {
        const list = this.querySelector('.py-look-items');
        if (!list) return;
        list.addEventListener('scroll', () => this.updateCarousel(), { ...options, passive: true });
        list.addEventListener('keydown', (event) => {
          if (event.target !== list || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(list).direction === 'rtl';
          this.scrollItems((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }, options);
        if ('ResizeObserver' in window) {
          this.carouselObserver = new ResizeObserver(() => this.updateCarousel());
          this.carouselObserver.observe(list);
        }
        this.updateCarousel();
      }
      updateCarousel() {
        const list = this.querySelector('.py-look-items');
        if (!list) return;
        const maximum = Math.max(0, list.scrollWidth - list.clientWidth);
        const position = Math.min(maximum, Math.max(0, Math.abs(list.scrollLeft)));
        const navigation = this.querySelector('[data-py-navigation]');
        if (navigation) navigation.hidden = maximum <= 1;
        const previous = this.querySelector('[data-py-prev]');
        const next = this.querySelector('[data-py-next]');
        if (previous) previous.disabled = position <= 1;
        if (next) next.disabled = position >= maximum - 1;
      }
      setupCompactOptions() {
        const area = this.querySelector('[data-py-options-area]');
        this.compactRows = new Map();
        for (const row of this.querySelectorAll('[data-py-item]')) {
          const panel = row.querySelector('[data-py-extra-options]') || Array.from(area?.children || []).find((element) => element.dataset.productId === row.dataset.productId);
          const controls = [...row.querySelectorAll('[data-py-option]')];
          if (panel) {
            for (const control of panel.querySelectorAll('[data-py-option]')) if (!controls.includes(control)) controls.push(control);
            area?.append(panel);
          }
          const fixed = Array.from(row.querySelectorAll('[data-py-fixed-option]')).map((element) => ({ position: element.dataset.optionPosition, value: element.dataset.optionValue }));
          this.compactRows.set(row.dataset.productId, { row, panel, controls, fixed });
          this.resolveCompactVariant(row);
        }
      }
      resolveCompactVariant(row) {
        const state = this.compactRows?.get(row.dataset.productId);
        if (!state) return;
        const select = row.querySelector('[data-py-variant]');
        const available = Array.from(select.options).filter((option) => option.value && !option.disabled);
        const selected = [...state.fixed];
        const matches = (variant, values) => values.every(({ position, value }) => variant.getAttribute(`data-option-${position}`) === value);
        for (const control of state.controls) {
          const position = control.dataset.optionPosition;
          for (const option of control.options) {
            if (!option.value) continue;
            option.disabled = !available.some((variant) => matches(variant, [...selected, { position, value: option.value }]));
          }
          if (control.selectedOptions[0]?.disabled) control.value = '';
          if (control.value) selected.push({ position, value: control.value });
        }
        const candidates = available.filter((variant) => matches(variant, selected));
        const complete = state.controls.every((control) => control.value && !control.selectedOptions[0]?.disabled);
        const choice = complete ? candidates[0] : null;
        select.value = choice?.value || '';
        const cheapest = candidates.reduce((lowest, variant) => !lowest || Number(variant.dataset.price) < Number(lowest.dataset.price) ? variant : lowest, null);
        const price = row.querySelector('[data-py-price]');
        if (choice) price.textContent = choice.dataset.money;
        else if (cheapest) {
          const varies = candidates.some((variant) => variant.dataset.price !== cheapest.dataset.price);
          price.textContent = `${varies ? this.dataset.fromLabel + ' ' : ''}${cheapest.dataset.money}`;
        } else price.textContent = '—';
        const preview = choice || candidates[0];
        const photo = row.querySelector('.py-look-item__photo');
        if (photo && preview?.dataset.image) {
          photo.removeAttribute('srcset');
          photo.src = preview.dataset.image;
        }
      }
      clearCompactErrors() {
        for (const { row, controls } of this.compactRows?.values() || []) {
          const error = row.querySelector('[data-py-item-error]');
          if (error) { error.hidden = true; error.textContent = ''; }
          for (const control of controls) control.removeAttribute('aria-invalid');
        }
      }
      focusCompactOptions(row) {
        const state = this.compactRows?.get(row.dataset.productId);
        if (!state) return;
        const missing = state.controls.find((control) => !control.value || control.selectedOptions[0]?.disabled);
        const error = row.querySelector('[data-py-item-error]');
        if (error) { error.textContent = this.dataset.missing; error.hidden = false; }
        this.update();
        if (missing) { missing.setAttribute('aria-invalid', 'true'); missing.focus(); }
      }
      drawerQuantityRule(choice) {
        const minimum = Math.max(1, Number(choice?.dataset.min || choice?.dataset.quantity || 1));
        const increment = Math.max(1, Number(choice?.dataset.increment || 1));
        const rawMaximum = Number(choice?.dataset.max);
        return { minimum, increment, maximum: Number.isFinite(rawMaximum) && rawMaximum > 0 ? rawMaximum : null };
      }
      quantityFor(row, choice) {
        const input = row.querySelector('[data-py-quantity-input]');
        if (!input) return Number(choice?.dataset.quantity || 1);
        const quantity = Number(input.value);
        return Number.isFinite(quantity) && quantity > 0 ? Math.floor(quantity) : 0;
      }
      syncDrawerButtons(row, rule, quantity) {
        const input = row.querySelector('[data-py-quantity-input]');
        if (!input) return;
        const disabled = input.disabled;
        const minus = row.querySelector('[data-py-quantity-minus]');
        const plus = row.querySelector('[data-py-quantity-plus]');
        if (minus) minus.disabled = disabled || quantity <= 0;
        if (plus) plus.disabled = disabled || (rule.maximum !== null && quantity >= rule.maximum);
      }
      setDrawerQuantity(row, requested) {
        const input = row.querySelector('[data-py-quantity-input]');
        if (!input) return;
        const choice = row.querySelector('[data-py-variant]')?.selectedOptions[0];
        const rule = this.drawerQuantityRule(choice);
        let quantity = Number(requested);
        if (!Number.isFinite(quantity) || quantity <= 0) quantity = 0;
        else {
          quantity = Math.max(rule.minimum, quantity);
          quantity = rule.minimum + Math.round((quantity - rule.minimum) / rule.increment) * rule.increment;
          if (rule.maximum !== null) quantity = Math.min(rule.maximum, quantity);
        }
        input.value = String(quantity);
        input.step = String(rule.increment);
        input.max = rule.maximum === null ? '' : String(rule.maximum);
        const check = row.querySelector('[data-py-check]');
        if (check && !check.disabled) check.checked = quantity > 0;
        this.syncDrawerButtons(row, rule, quantity);
      }
      changeDrawerQuantity(row, direction) {
        const input = row.querySelector('[data-py-quantity-input]');
        if (!input || input.disabled) return;
        const choice = row.querySelector('[data-py-variant]')?.selectedOptions[0];
        const rule = this.drawerQuantityRule(choice);
        const current = this.quantityFor(row, choice);
        const quantity = direction > 0 ? (current <= 0 ? rule.minimum : current + rule.increment) : (current <= rule.minimum ? 0 : current - rule.increment);
        this.setDrawerQuantity(row, quantity);
      }
      syncDrawerVariant(row, choice) {
        const input = row.querySelector('[data-py-quantity-input]');
        if (!input) return;
        const current = this.quantityFor(row, choice);
        const rule = this.drawerQuantityRule(choice);
        this.setDrawerQuantity(row, current > 0 ? current : rule.minimum);
      }
      selectedRows() { return Array.from(this.querySelectorAll('[data-py-item]')).filter((row) => row.querySelector('[data-py-check]').checked && !row.querySelector('[data-py-check]').disabled); }
      getItems() {
        const rows = this.selectedRows();
        if (!rows.length) { this.message(this.dataset.empty); return null; }
        const items = [];
        for (const row of rows) {
          const select = row.querySelector('[data-py-variant]');
          const choice = select.selectedOptions[0];
          if (!choice?.value || choice.disabled) {
            this.message(this.dataset.missing);
            if (this.dataset.compact === 'true') this.focusCompactOptions(row);
            else select.focus();
            return null;
          }
          items.push({ id: Number(choice.value), quantity: this.quantityFor(row, choice) });
        }
        return items;
      }
      formatMoney(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
      }
      mainPricingLine() {
        if (!this.form) return null;
        const fields = new FormData(this.form);
        const variantId = String(fields.get('id') || '');
        const option = Array.from(this.querySelectorAll('[data-py-main-variants] option')).find((item) => item.value === variantId);
        const quantity = Number(fields.get('quantity') || 1);
        const price = Number(option?.dataset.price);
        if (!option || option.dataset.available !== 'true' || !Number.isSafeInteger(quantity) || quantity < 1 || !Number.isSafeInteger(price) || price < 0) return null;
        return { price, quantity, eligible: this.dataset.mainPromoEligible === 'true' && !fields.get('selling_plan') };
      }
      compactPricingState(rows, hasMissingOptions) {
        const main = this.mainPricingLine();
        if (!main || hasMissingOptions) return null;
        const lines = [main];
        for (const row of rows) {
          const choice = row.querySelector('[data-py-variant]')?.selectedOptions[0];
          const price = Number(choice?.dataset.price);
          const quantity = Number(choice?.dataset.quantity || 1);
          if (!choice?.value || choice.disabled || !Number.isSafeInteger(price) || price < 0 || !Number.isSafeInteger(quantity) || quantity < 1) return null;
          lines.push({ price, quantity, eligible: row.dataset.promoEligible === 'true' });
        }
        const totalUnits = lines.reduce((sum, line) => sum + line.quantity, 0);
        const subtotal = lines.reduce((sum, line) => sum + line.price * line.quantity, 0);
        const eligibleLines = lines.filter((line) => line.eligible).sort((first, second) => first.price - second.price);
        const eligibleUnits = eligibleLines.reduce((sum, line) => sum + line.quantity, 0);
        const freeUnits = Math.floor(eligibleUnits / 3);
        let freeRemaining = freeUnits;
        let savings = 0;
        for (const line of eligibleLines) {
          if (freeRemaining <= 0) break;
          const discountedQuantity = Math.min(line.quantity, freeRemaining);
          savings += line.price * discountedQuantity;
          freeRemaining -= discountedQuantity;
        }
        const remainder = eligibleUnits % 3;
        const meterUnits = freeUnits > 0 && remainder === 0 ? 3 : remainder;
        const needed = freeUnits > 0 && remainder === 0 ? 0 : 3 - remainder;
        return { totalUnits, subtotal, eligibleUnits, freeUnits, savings, estimated: subtotal - savings, meterUnits, needed, mainEligible: main.eligible };
      }
      renderCompactPricing(state) {
        const subtotalLabel = this.querySelector('[data-py-subtotal]');
        const countLabel = this.querySelector('[data-py-count]');
        const eligibleLabel = this.querySelector('[data-py-eligible-count]');
        const meter = this.querySelector('[data-py-promo-bar]');
        const progress = this.querySelector('[data-py-promo-progress]');
        const discount = this.querySelector('[data-py-promo-discount]');
        const savingsLabel = this.querySelector('[data-py-savings]');
        const estimatedLabel = this.querySelector('[data-py-estimated]');
        if (!state) {
          if (countLabel) countLabel.textContent = '';
          if (subtotalLabel) subtotalLabel.textContent = '—';
          if (eligibleLabel) eligibleLabel.textContent = '';
          if (meter) meter.style.width = '0%';
          if (progress) progress.textContent = this.dataset.promoChooseOptions || this.dataset.missing;
          if (discount) discount.hidden = true;
          if (savingsLabel) savingsLabel.textContent = '—';
          if (estimatedLabel) estimatedLabel.textContent = '—';
          return;
        }
        const itemTemplate = state.totalUnits === 1 ? this.dataset.promoItemsOne : this.dataset.promoItemsMany;
        if (countLabel) countLabel.textContent = (itemTemplate || '').replace('[count]', String(state.totalUnits));
        if (subtotalLabel) subtotalLabel.textContent = this.formatMoney(state.subtotal);
        if (eligibleLabel) eligibleLabel.textContent = (this.dataset.promoEligibleCount || '').replace('[count]', String(state.meterUnits));
        if (meter) meter.style.width = `${Math.min(100, state.meterUnits / 3 * 100)}%`;
        if (progress) {
          let message = '';
          if (state.freeUnits === 0) {
            const template = state.needed === 1 ? this.dataset.promoAddOne : this.dataset.promoAddMany;
            message = (template || '').replace('[count]', String(state.needed));
          } else {
            const unlocked = state.freeUnits === 1 ? this.dataset.promoUnlockedOne : (this.dataset.promoUnlockedMany || '').replace('[count]', String(state.freeUnits));
            if (state.needed > 0) {
              const next = state.needed === 1 ? this.dataset.promoAnotherOne : (this.dataset.promoAnotherMany || '').replace('[count]', String(state.needed));
              message = `${unlocked} · ${next}`;
            } else message = unlocked;
          }
          progress.textContent = state.mainEligible ? message : `${this.dataset.promoMainExcluded} · ${message}`;
        }
        if (discount) discount.hidden = state.freeUnits === 0;
        if (savingsLabel) savingsLabel.textContent = `−${this.formatMoney(state.savings)}`;
        if (estimatedLabel) estimatedLabel.textContent = this.formatMoney(state.estimated);
      }
      updateCompactPricing(rows, hasMissingOptions) {
        this.renderCompactPricing(this.compactPricingState(rows, hasMissingOptions));
      }
      update() {
        const rows = this.selectedRows();
        let total = 0;
        for (const row of rows) {
          const choice = row.querySelector('[data-py-variant]').selectedOptions[0];
          if (choice?.value && !choice.disabled) total += Number(choice.dataset.price) * this.quantityFor(row, choice);
        }
        const totalLabel = this.querySelector('[data-py-total]');
        const hasMissingOptions = rows.some((row) => !row.querySelector('[data-py-variant]').value);
        if (this.dataset.compact === 'true') this.updateCompactPricing(rows, hasMissingOptions);
        else if (totalLabel) totalLabel.textContent = hasMissingOptions ? '—' : this.formatMoney(total);
        const selection = this.querySelector('[data-py-selection]');
        if (selection) selection.hidden = this.dataset.compact === 'true' ? false : !rows.length;
        const countLabel = this.querySelector('[data-py-count]');
        if (countLabel && this.dataset.compact !== 'true') countLabel.textContent = (this.dataset.countLabel || '').replace('[count]', String(rows.length));
        let visiblePanels = 0;
        for (const { row, panel } of this.compactRows?.values() || []) {
          const selected = rows.includes(row);
          row.classList.toggle('is-selected', selected);
          if (panel) { panel.hidden = !selected; if (selected) visiblePanels += 1; }
        }
        const optionsArea = this.querySelector('[data-py-options-area]');
        if (optionsArea) optionsArea.hidden = visiblePanels === 0;
        const extraAdd = this.querySelector('[data-py-add]');
        if (extraAdd) {
          extraAdd.disabled = !rows.length;
          if (this.dataset.compact === 'true') extraAdd.hidden = !rows.length;
        }
        this.updatePaymentButtons();
      }
      updatePaymentButtons() {
        if (!this.form) return;
        const selected = this.selectedRows().length > 0;
        this.paymentButtons ||= new Map();
        for (const payment of this.form.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout')) {
          if (!this.paymentButtons.has(payment)) this.paymentButtons.set(payment, payment.hidden);
          payment.hidden = selected || this.paymentButtons.get(payment);
        }
      }
      restorePaymentButtons() { for (const [element, hidden] of this.paymentButtons || []) element.hidden = hidden; }
      scrollItems(direction) {
        const list = this.querySelector('.py-look-items');
        if (!list) return;
        const compact = this.dataset.compact === 'true';
        const style = getComputedStyle(list);
        const gap = parseFloat(style.columnGap) || 0;
        const step = compact ? (list.firstElementChild?.getBoundingClientRect().width || list.clientWidth / 3) + gap : list.clientWidth * .8;
        list.scrollBy({ left: direction * step * (style.direction === 'rtl' ? -1 : 1), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      message(text) { this.querySelector('[data-py-message]').textContent = text; }
      submitExtras(button) { const items = this.getItems(); if (items) this.addItems(items, button); }
      async addItems(items, button) {
        if (this.constructor.pending) return;
        this.constructor.pending = true;
        button?.setAttribute('aria-disabled', 'true');
        const spinner = button?.querySelector('.loading__spinner');
        spinner?.classList.remove('hidden');
        this.message('');
        const root = window.Shopify?.routes?.root || '/';
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = cart?.getSectionsToRender?.().map((section) => section.id) || [];
        const payload = { items };
        if (sections.length) { payload.sections = sections; payload.sections_url = window.location.pathname + window.location.search; }
        let committed = false;
        try {
          const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
          const data = await response.json();
          if (!response.ok || data.status) {
            this.message(typeof data.description === 'string' ? data.description : this.dataset.error);
            this.querySelector('[data-py-cart-link]').hidden = false;
            return;
          }
          committed = true;
          this.message(this.dataset.success);
          this.querySelector('[data-py-cart-link]').hidden = false;
          const dialog = this.closest('dialog');
          const trigger = dialog?.closest('py-look-card')?.querySelector('[data-py-open]') || button;
          if (dialog?.open) dialog.close();
          if (this.dataset.mode === 'pdp') { this.selectedRows().forEach((row) => { row.querySelector('[data-py-check]').checked = false; }); this.update(); }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'py-shop-the-look', productVariantId: items[0].id, cartData: data });
          if (cart?.renderContents && sections.every((id) => typeof data.sections?.[id] === 'string')) {
            cart.setActiveElement?.(trigger);
            cart.classList.remove('is-empty');
            cart.renderContents({ ...data, id: data.items?.[0]?.id, key: data.items?.[0]?.key });
          } else if (dialog) {
            window.location.assign(root + 'cart');
          }
        } catch (error) {
          this.message(committed ? this.dataset.success : this.dataset.uncertain);
          this.querySelector('[data-py-cart-link]').hidden = false;
        } finally {
          this.constructor.pending = false;
          button?.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
